
  <wiz-vgroup class="section-container" height="100%" width="100%" (click)="tap()" gap="0">
    <wiz-hgroup *ngIf="showCloseButton" width="100%" horizontalAlign="end">
      <wiz-icon class="image-inactive" (click)="hide()">close</wiz-icon>
    </wiz-hgroup>

    <!-- rendu standard, icon + texte -->
    <wiz-hgroup *ngIf="!customRenderer" height="100%" width="100%" verticalAlign="center">
      <wiz-vgroup height="50px" width="50px">
        <wiz-image *ngIf="icon" [source]="icon" height="100%" width="100%"></wiz-image>
      </wiz-vgroup>
      <wiz-vgroup height="100%" width="100%" verticalAlign="center">
        <div width="100%" [innerHTML]="contentStr"></div>
        <!-- <wiz-label #lblDetail [wizLabel]="contentStr" [wizTextBehavior]="'wordWrap'" width="100%"> 
        </wiz-label>-->
      </wiz-vgroup>
    </wiz-hgroup>
    <!-- rendu custom -->
    <wiz-hgroup *ngIf="customRenderer" height="100%" width="100%" horizontalAlign="center">
      <ng-container #rendererContainer></ng-container>
    </wiz-hgroup>

  </wiz-vgroup>

